const comments = [
  {
    id: 1,
    name: '爱吃瓜的小明',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20style%20portrait%2C%20warm%20coral%20tones%2C%20geometric%20shapes%2C%20flat%20design%2C%20clean%20simple%20illustration%2C%20no%20text&width=80&height=80&seq=avatar-1-2026&orientation=squarish',
    text: '这个站太全了！之前找51黑料网站和91黑料网站还要到处搜，现在一个页面全搞定，吃瓜效率直接拉满。每天刷一遍，再也不怕错过任何大瓜。',
    time: '2小时前',
    likes: 1283,
    source: '来自51黑料网站评论区',
  },
  {
    id: 2,
    name: '娱乐圈探照灯',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20style%20portrait%2C%20amber%20warm%20tones%2C%20geometric%20shapes%2C%20flat%20design%2C%20clean%20simple%20illustration%2C%20no%20text&width=80&height=80&seq=avatar-2-2026&orientation=squarish',
    text: '作为资深吃瓜群众，这个黑料网站推荐合集确实靠谱。收录的网红黑料网站来源质量都很高，不像有些导航站全是广告和水贴，用了一个月没踩过雷。',
    time: '5小时前',
    likes: 967,
    source: '来自吃瓜黑料网站热评',
  },
  {
    id: 3,
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20style%20portrait%2C%20warm%20rose%20tones%2C%20geometric%20shapes%2C%20flat%20design%2C%20clean%20simple%20illustration%2C%20no%20text&width=80&height=80&seq=avatar-3-2026&orientation=squarish',
    text: '最新黑料网站更新速度真的快，基本和源头同步。上次某网红翻车，这边几分钟后就上了热门话题，比微博热搜还快。推荐给所有爱吃瓜的朋友！',
    time: '8小时前',
    likes: 2105,
    source: '来自91黑料网站讨论区',
  },
  {
    id: 4,
    name: '瓜田里的守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20style%20portrait%2C%20warm%20terracotta%20tones%2C%20geometric%20shapes%2C%20flat%20design%2C%20clean%20simple%20illustration%2C%20no%20text&width=80&height=80&seq=avatar-4-2026&orientation=squarish',
    text: '黑料网站大全名副其实！从明星八卦到网红翻车，从业内爆料到综艺黑幕，分类清晰更新勤快。相比之前东奔西跑找瓜吃，现在每天打开这一个就够了。',
    time: '1天前',
    likes: 856,
    source: '来自网红黑料网站留言',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            吃瓜热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            真实用户反馈，看看大家怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-100/60 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {comment.text}
                  </p>
                  <div className="flex items-center justify-between mt-4 flex-wrap gap-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.source}</span>
                    <span className="flex items-center gap-1.5 text-xs text-foreground-400 whitespace-nowrap">
                      <i className="ri-thumb-up-line"></i>
                      {comment.likes.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}